import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as carrerasService from '../../services/carreras/carrerasService';
import {
  classifyCarrerasError,
  toCreateCarreraPayload,
  validateCarreraForm
} from '../../services/carreras/carrerasDto';

export class AddCarrera extends Component {
  static displayName = AddCarrera.name;

  constructor(props) {
    super(props);
    this.state = { loading: false, anioImplementacion: new Date().getFullYear().toString(), name: "", showErrorMessage: false, success: false, errorMessage: "", resolucionMinisterial: "" };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleAnioImplementacion = this.handleAnioImplementacion.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handleResolucionMinisterial = this.handleResolucionMinisterial.bind(this);
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveCarrera();
    } else {
      this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });
    }
  }

  async componentDidMount() {
    await constantClass.canAccess('WWCarreras');
  }

  handleAnioImplementacion = e => {
    this.setState({ anioImplementacion: e.target.value });
  }

  handleResolucionMinisterial = e => {
    this.setState({ resolucionMinisterial: e.target.value });
  }

  handleNameChangeInput = e => {
    this.setState({ name: e.target.value });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-carreras" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-carrera">
        <Link className="md-page__back-link" to="/md-carreras">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Carrera</h1>
        </div>
        <p className="md-page__subtitle">
          Complete los datos de la carrera para registrarla en el sistema.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-nombre">
              Nombre Completo
            </label>
            <input
              id="carrera-nombre"
              className="md-page__field-input"
              name="name"
              placeholder="Ingrese Nombre Completo"
              onChange={this.handleNameChangeInput}
              disabled={loading}
              value={this.state.name}
              required
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-anio">
              Año de Implementación
            </label>
            <input
              id="carrera-anio"
              className="md-page__field-input md-page__field-input--year"
              name="anioImplementacion"
              placeholder="Ingrese Año Implementación"
              onChange={this.handleAnioImplementacion}
              disabled={loading}
              value={this.state.anioImplementacion}
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="carrera-resolucion">
              Resolución Ministerial
            </label>
            <input
              id="carrera-resolucion"
              className="md-page__field-input"
              name="resolucionMinisterial"
              placeholder="Ingrese Resolución de Aprobación"
              onChange={this.handleResolucionMinisterial}
              disabled={loading}
              value={this.state.resolucionMinisterial}
              required
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    );
  }

  isOkToSave() {
    return validateCarreraForm({
      name: this.state.name,
      anioImplementacion: this.state.anioImplementacion,
      resolucionMinisterial: this.state.resolucionMinisterial,
      extinta: 'N'
    });
  }

  async saveCarrera() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await carrerasService.saveCarrera(
        toCreateCarreraPayload({
          name: this.state.name,
          anioImplementacion: this.state.anioImplementacion,
          resolucionMinisterial: this.state.resolucionMinisterial
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCarrerasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
